/**
 * RumorsTab — renders the Rumors list from a `JournalTabState`.
 *
 * Each rumor renders as a name (heading) + hint (body). No footnote — a
 * rumor is either present or absent in the journal; there is no "unread"
 * for rumors. Newest-first ordering is decided by the dispatch helper.
 */

import * as Phaser from 'phaser';
import {
  JOURNAL_FONT,
  JOURNAL_INK,
  JOURNAL_INK_MUTED,
  JOURNAL_FONT_SIZE,
  JOURNAL_LAYOUT,
} from './journalTheme';
import type { JournalTabState } from './journalDispatch';

export function renderRumorsTab(
  scene: Phaser.Scene,
  container: Phaser.GameObjects.Container,
  state: JournalTabState,
): void {
  container.removeAll(true);
  if (state.lines.length === 0) {
    const text = scene.add.text(0, 24, state.emptyMessage, {
      fontFamily: JOURNAL_FONT,
      fontSize: JOURNAL_FONT_SIZE.EMPTY_STATE,
      color: JOURNAL_INK_MUTED,
      fontStyle: 'italic',
      wordWrap: {
        width: JOURNAL_LAYOUT.CONTENT_WIDTH - JOURNAL_LAYOUT.CONTENT_PAD_X * 2,
      },
    });
    container.add(text);
    return;
  }

  let y = 0;
  for (const line of state.lines) {
    if (line.heading) {
      const heading = scene.add.text(0, y, line.heading, {
        fontFamily: JOURNAL_FONT,
        fontSize: JOURNAL_FONT_SIZE.HEADING,
        color: JOURNAL_INK,
      });
      container.add(heading);
      y += 22;
    }

    const body = scene.add.text(0, y, line.body, {
      fontFamily: JOURNAL_FONT,
      fontSize: JOURNAL_FONT_SIZE.BODY,
      color: JOURNAL_INK_MUTED,
      fontStyle: 'italic',
      wordWrap: {
        width: JOURNAL_LAYOUT.CONTENT_WIDTH - JOURNAL_LAYOUT.CONTENT_PAD_X * 2,
      },
    });
    container.add(body);
    y += body.height + JOURNAL_LAYOUT.LINE_SPACING;
  }
}
